import { useMutation, useQuery } from "convex/react"
import { api } from "../../../../convex/_generated/api"
import type { Id } from "../../../../convex/_generated/dataModel"

/**
 * Bookmark state for the browse board and job detail. Queries are skipped
 * entirely unless the viewer is a logged-in seeker, so anonymous and employer
 * views cost nothing.
 */
export function useSavedJobs() {
  const me = useQuery(api.profiles.me)
  const isSeeker = me?.role === "seeker"
  const savedIds = useQuery(api.savedJobs.savedJobIds, isSeeker ? {} : "skip")
  const toggleMutation = useMutation(api.savedJobs.toggle)

  return {
    /** undefined while the profile is still loading. */
    isSeeker: me === undefined ? undefined : isSeeker,
    isSaved: (jobId: Id<"jobs">) => (savedIds ?? []).includes(jobId),
    toggle: (jobId: Id<"jobs">) => toggleMutation({ jobId }),
  }
}

export function useSavedJobsList() {
  const items = useQuery(api.savedJobs.listMine)
  const toggleMutation = useMutation(api.savedJobs.toggle)
  return {
    items,
    unsave: (jobId: Id<"jobs">) => toggleMutation({ jobId }),
  }
}

export function useJobAlerts() {
  const alerts = useQuery(api.candidateJobAlerts.listMine)
  const createMutation = useMutation(api.candidateJobAlerts.create)
  const removeMutation = useMutation(api.candidateJobAlerts.remove)
  return {
    alerts,
    create: (filters: { q?: string; employmentType?: string; regions?: string[] }) =>
      createMutation(filters),
    remove: (alertId: Id<"candidateJobAlerts">) => removeMutation({ alertId }),
  }
}
